<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="collection_keyno" [ttModel]="menu.collection_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="collection_name" [ttModel]="menu.collection_name" [ttButtons]="collectionNameButtons" ttReadonly></tt-input>
        <tt-input ttLabel="collection_status" [ttModel]="menu.collection_status" ttReadonly></tt-input>
        <tt-button-goto [ttText]="'collectionmenu_edit'" [ttGoto]="'collection'" [ttGotoParms]="{ collection_keyno: menu.collection_keyno }"></tt-button-goto>
        <tt-button *ngIf="collectionKeyno !== '0'" ttText="collectionmenu_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </tt-card>
</tt-page>
